import React from 'react';

const ListPilgrimages = () => {
  return (
    <div>
      <a href='https://vrtourpilgrimage.netlify.app/pilgrimage'>Pilgrimages</a>
    </div>
  );
};

export default ListPilgrimages;
